import CustomButton from 'Components/CustomButton'
import CustomDialog from 'Components/CustomDialog'
import type { WebShopOrderLineLogShape } from 'Services/SalesManagement/Features/Order/orderSlice'
import { dateFormatter } from 'Util/formatters'
import { Box, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material'
import type { FC } from 'react'
import { t } from 'ttag'

const LogDialog: FC<{
  open: boolean
  handleClose: () => void
  log: WebShopOrderLineLogShape[]
}> = ({ open, handleClose, log }) => {
  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle>{t`Order line log`}</DialogTitle>
      <DialogContent>
        {log.length > 0 ? (
          log.map((logEntry, i) => (
            <Box key={logEntry.object_id} sx={{ p: 0.5 }}>
              {i > 0 && <Divider />}
              <Typography variant="caption">
                {t`Created`.toUpperCase()}
                {` ${dateFormatter(new Date(logEntry.created), 'dd.MM.yyyy')}`}
              </Typography>
              <Typography variant="body1">{logEntry.message}</Typography>
            </Box>
          ))
        ) : (
          <Typography variant="body1">{t`No log to show for this order line`}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={handleClose}>{t`Close`}</CustomButton>
      </DialogActions>
    </CustomDialog>
  )
}

export { LogDialog }
